export const OPPORTUNITY_CENTER_TEL_FORMATTED = "+41 61 277 65 05";
